import Vue from 'vue';
import App from './App.vue';
import store from './store';
import './registerServiceWorker';
import VueResource from 'vue-resource';

import 'whatwg-fetch'; // Fetch Polyfill für IE

import SVGIcon from './components/CoreComponents/SVGIcon.vue';

Vue.config.productionTip = false;

Vue.use(VueResource);

Vue.directive('click-outside', {
  bind: (el, binding, vnode) => {
    el.event = (event) => {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.event);
  },
  unbind: (el) => {
    document.body.removeEventListener('click', el.event);
  }
});

Vue.component('SVGIcon', SVGIcon);

new Vue({
  store,
  beforeCreate() {
    this.$store.dispatch('initialiseStore');
  },
  render: h => h(App)
}).$mount('#app');
